import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);
const STORAGE_KEY = "tijuas-lang";

const getInitialLang = () => {
  const saved = window.localStorage.getItem(STORAGE_KEY);
  if (saved === "en" || saved === "es") return saved;
  return navigator.language?.toLowerCase().startsWith("es") ? "es" : "en";
};

const lookup = (obj, path) => path.split(".").reduce((acc, k) => (acc == null ? acc : acc[k]), obj);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(getInitialLang);

  useEffect(() => {
    document.documentElement.lang = lang;
    window.localStorage.setItem(STORAGE_KEY, lang);
  }, [lang]);

  const value = useMemo(() => {
    const t = (key) => lookup(translations[lang], key) ?? lookup(translations.en, key) ?? key;
    return { lang, setLang, t, isEs: lang === "es" };
  }, [lang]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => useContext(LanguageContext);

// Pick a localized string from {en, es} objects used in data files
export const pick = (value, lang) => (value && typeof value === "object" ? value[lang] ?? value.en : value);
